<template>
  <div class="box">
    <!-- 矩阵问题 -->
    <GlobalInfoBar title="矩阵管理" content="添加矩阵、管理矩阵报价回收商以及矩阵设置" />
    <!-- 查询 -->
    <GlobalChunk icon="search" title="筛选查询">
      <!-- 筛选 -->
      <template v-slot:filter>
        <GlobalForm :form-item-list="formItemList" round size="mini" :inline="true" :init-data="initData"
          :needBtnLoading="true" @handleConfirm="handleConfirm" confirm-btn-name="查询" @handleChange="handleChange">
          <el-form-item label="报价状态" slot="sxwx" style="margin:0">
            <el-select v-model="status" placeholder="请选择" filterable clearable :disabled="disabled">
              <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!--新增厂商-->
          <el-form-item label="厂商" slot="manufacturer" style="margin:0">
            <el-select v-model="manufacturer" placeholder="请选择" filterable clearable>
              <el-option v-for="item in manufaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <template v-slot:AddSlot>
            <el-button type="primary" icon="el-icon-plus" @click="createClick">新建矩阵</el-button>
          </template>
        </GlobalForm>
      </template>
      <!--  表+头    -->
      <template v-slot:default>
        <!-- 头 -->
        <div class="table-header">
          <div class="header-icon">
            <!-- <img src="@/assets/images/icon_lb@2x.png" alt="" />
            <h2>矩阵列表</h2> -->
                   <div class="button_top">
          <div class="radiobtn">
            <div class="faultBtn">
              <div v-bind:class="inOrOutClickShow === '01' ? 'active' : 'none'"
                @click="inOrOutChange('01')">
                外部矩阵
              </div>
              <div v-bind:class="inOrOutClickShow === '02' ? 'active' : 'none'"
                @click="inOrOutChange('02')">
                内部矩阵
              </div>
            </div>
          </div>
                   </div>
          </div>
          <div>
            <el-button type="success" @click="openMerchantBatchDia">回收商批量操作</el-button>
            <el-button style="margin-top: -10px" type="primary" @click="addStore"
              :disabled="addStoreBtn">批量添加回收商</el-button>
          </div>
        </div>
        <!-- 表 -->
        <el-table ref="listData" border size="small" :header-cell-style="{ background: '#E4ECFD', padding: 0 }"
          v-loading="loading" :data="listData" @selection-change="handleTableSelect">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column v-for="item in currentlistColumns" :key="item.prop" :prop="item.prop" align="center"
            :label="item.label" :width="item.width">
            <template v-slot="{ row }">
              <div v-if="item.prop === 'channelName1'">
               <span style="color: #0981FF;">{{ row.channelName }}</span>
              </div>
              <div v-if="item.prop === 'parameterConfi'">
               <el-button type="text" style="text-decoration: underline;" @click="parameterConfiClick(row)">配置</el-button>
              </div>
              <div v-if="item.prop === 'quotationConfi'">
               <el-button type="text" style="text-decoration: underline;" @click="nodeShowClick(row)">推送报价配置</el-button>
              </div>
              <div v-if="item.prop === 'afterSalesConfi'">
               <el-button type="text" style="text-decoration: underline;" @click="afterSalesConfig(row)">售后配置</el-button>
              </div>
              <!-- 操作-->
              <div v-if="item.prop === 'action'">
                <div v-if="row.isOut === '是'">
                  <el-tooltip class="item" effect="dark" content="外部渠道商无法设置矩阵" placement="top-start">
                    <div class="f-line">矩阵设置</div>
                  </el-tooltip>
                </div>
                <!-- <div class="fc_line" v-if="row.isOut === '否'" @click="settingClick(row)"> -->
                <div class="fc_line" v-if="row.isOut === '否'" @click="$refs['settingDia'].open(row)">
                  矩阵设置
                </div>
                <div v-if="row.isOut === '--'">--</div>
              </div>

              <!-- 是否外部渠道-->
              <div v-else-if="item.prop === 'isOut'">
                <!-- 是否外部渠道商 -->
                <div v-if="row[item.prop] === '--'">--</div>
                <div v-if="row[item.prop] === '是'">
                  <span>是</span>
                  <p class="fc">{{ row.channelName }}</p>
                </div>
                <div v-if="row[item.prop] === '否'">
                  <span>否</span>
                </div>
              </div>
              <!-- 外部商户号/渠道-->
              <div v-else-if="item.prop === 'Outchannel' ">
                {{ row.routeId }}
                <!-- 是否外部渠道商 -->
                <!-- <div
                  v-if="(row.outMerchantId === '--' && row.chxChannelCode === '--') || (row.channelCode !== 'xm' && row.channelCode !== 'ygx')">
                  --</div>
                <div v-else>
                  <div>商户号：{{ row.outMerchantId || "--" }}</div>
                  <div v-if="row.chxChannelCode === '--'" style="color:red">未绑定渠道ID</div>
                  <div v-else style="display: flex;
                  align-items: center;">
                    <el-tag size="small" type="warning" v-if="row.isDefault">默认</el-tag>
                    <span>渠道ID：{{ row.chxChannelCode }}</span>
                  </div>
                </div> -->
              </div>
              <!-- 繁星渠道编码-->
              <div v-else-if="item.prop === 'fxChannelCode'">
                <!-- 是否外部渠道商 -->
                <div v-if="row.fxChannelCode !== '--'">{{ row.fxChannelCode }}</div>
                <div v-if="row.fxChannelCode == '--'" class="fc_line danger" @click="setChanelCode(row.id)">设置</div>
              </div>
              <!-- 是否厂家订单-->
              <div v-else-if="item.prop === 'isManufacturers'">
                <!-- 是否外部渠道商 -->
                <div v-if="row[item.prop]">是</div>
                <div v-else>否</div>
                <template v-if="row.isOut === '是'">
                  <div v-if="row[item.prop]" class="fc_line" @click="$refs['tagDia'].open(row, '01')">
                    取消标记厂家订单
                  </div>
                  <div v-else class="fc_line danger" @click="$refs['tagDia'].open(row, '00')">
                    标记厂家订单
                  </div>
                </template>
              </div>
              <!--所属厂商-->
              <div v-else-if="item.prop === 'belongManufacturers'">
                <!--未标记厂商订单、非外部矩阵商户显示-->
                <span v-if="row.isOut == '否'||(row.isOut === '是'&&!row.isManufacturers)">无需设置</span>
                <!--外部矩阵商户且未设置厂商-->
                <div v-if="row.isOut === '是' && row.manufacturerName == '--'&&(row.isOut === '是'&&row.isManufacturers)">
                  <div>暂未设置</div>
                  <div style="color: #f93636;text-decoration: underline;cursor: pointer;" @click="setManufa(row, 'add')">
                    设置</div>
                </div>
                <!--外部矩阵一设置-->
                <div v-if="row.isOut === '是' && row.manufacturerName && row.manufacturerName !== '--'&&(row.isOut === '是'&&row.isManufacturers)">
                  <div style="color: #0981ff;">{{ row.manufacturerName }}</div>
                  <div style="color: #f93636;text-decoration: underline;cursor: pointer;"
                    @click="setManufa(row, 'edit')">修改</div>
                </div>
              </div>
              <div v-else-if="item.prop === 'pushFactor'">
                <div v-if="row['isOrderNoRule'] === true && row[item.prop] !== '--'">{{ row[item.prop] }}</div>
                <div v-else style="color: #FF687B;">未启用</div>
                <div class="fc_line" @click="openPushFactorSet(row)">设置</div>
              </div>
              <!-- 报价回收商 -->
              <div v-else-if="item.prop === 'merchantNum'">
                <div class="fc_line" @click="recoveryNum(row)">
                  {{ row[item.prop] }}
                </div>
                <div class="fc_line" @click="addRecovery(row)">添加</div>
              </div>

              <!-- 包含门店商 -->
              <div v-else-if="item.prop === 'companyNum'">
                <div v-if="row.isOut === '是'">--</div>
                <a v-else class="fc_line" @click="storeListHref(row)" target="_blank"
                  :href="`/StoreShop/index?matrixId=${row.id}&matrixName=${row.matrixName}`">
                  {{ row[item.prop] }}
                </a>
              </div>
              <!-- 矩阵回收商 -->
              <div v-else-if="item.prop === 'merchantName'">
                <div v-if="row.isOut === '是'">外部渠道无需设置</div>
                <div v-else class="fc_line" @click="
                  openAction(`/merchant/list?merchantName=${row[item.prop]}`)
                  ">
                  {{ row[item.prop] }}
                </div>
              </div>

              <!-- 矩阵门店商户 -->
              <div v-else-if="item.prop === 'companyName'" class="fc_line">
                <p v-if="row[item.prop] !== '--'" @click="
                  openAction(`/StoreShop/index?companyName=${row[item.prop]}`)
                  ">
                  {{ row[item.prop] }}
                </p>
                <p v-else>--</p>
              </div>
              
               <!-- 发货配置 -->
              <div v-else-if="item.prop === 'channelCode'">
                
                <el-button type="text" style="text-decoration: underline;" @click="configurationId = row.id,configuration()" v-if="row.channelCode === 'lb-new'">配置</el-button>
                <span  style="color: lightgray;" v-else>配置</span>
              </div>

              <!-- 默认渲染 -->
              <div v-else>
                {{ row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <Pagination :meta="meta" @sizeChange="(v) => {
          meta = { ...meta, pageSize: v };
          params = { ...params, pageSize: v };
        }
        " @pageChange="(v) => {
            meta = { ...meta, pageNum: v };
            params = { ...params, pageNum: v };
          }
          " />
      </template>
    </GlobalChunk>
    <el-dialog title="发货配置" :visible.sync="configurationShow" width="900px" :before-close="() => (configurationShow = false,getList())">
    <el-table
      :data="configurationData"
      style="width: 100%;margin: 20px 0;">
          <el-table-column
      type="index"
      width="50"
      label="序号"
      align="center"
      >
    </el-table-column>
      <el-table-column
        prop="operatorCodeName"
        label="配置功能"
        align="center"
        >
      </el-table-column>
      <el-table-column
        label="当前配置"
        align="center"
        >
      <template slot-scope="scope">
       
       <el-switch v-if="scope.row.operatorCodeName == '是否开启自动呼叫快递'" @change="configurationSwitchShow = true,openOrClose = scope.row.openOrClose"
  v-model="scope.row.openOrClose">
</el-switch>
  <span v-else>支持</span>
      </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="最近修改人">
              <template slot-scope="scope">
       {{ scope.row.operatorName }} - {{ scope.row.operatorAcc }}
      </template>
      </el-table-column>
       <el-table-column
        prop="operatorTime"
        align="center"
        label="最近修改时间">
              <template slot-scope="scope">
       {{ scope.row.operatorTime || '--' }}
      </template>
      </el-table-column>
       <el-table-column
        prop="active"
        align="center"
        label="操作">
           <template>
       --
      </template>
      </el-table-column>
    </el-table>
    </el-dialog>
        <el-dialog
      title="操作提示"
      :visible.sync="configurationSwitchShow"
      :close-on-click-modal="false"
      width="530px"
      @closed="configurationSwitchShow = false,command='',configuration()"
    >
      <div>
        <div style="color: red;">说明：{{ openOrClose?'启用后，平台每日将定时自动呼叫快递':'关闭后，平台将不再自动呼叫快递' }}</div>
        <span style="height:40px;display:flex;justify-content: center;margin: 20px 0;">是否确认{{openOrClose?'启用':'关闭'}}平台自动呼叫快递？</span>
        <div class="command">
          <div style="width: 85px;">动态口令：</div>
          <el-input
            v-model="command"
            placeholder="请输入谷歌动态口令"
            oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click.native="configurationSwitchSubmit()">确定</el-button>
        <el-button @click.native="configurationSwitchShow=false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 矩阵新建弹窗 -->
    <el-dialog title="新建矩阵" :visible.sync="isCreateShow" width="40%" :before-close="() => (isCreateShow = false)">
      <h2 class="tip">说明：繁星自有矩阵添加后需要配置报价回收商才可使用</h2>
      <el-form class="create-form" :model="createMatrixForm" :rules="createMatrixRules" ref="createMatrix"
        label-width="140px" label-position="left">
        <el-form-item :label="item.label" :prop="item.key" v-for="(item, index) in createMatrixFormList" :key="index"
          v-show="item.isShow">
          <!-- 输入，需要结合type判断 -->
          <el-input clearable :disabled="item.disabled" v-model="createMatrixForm[item.key]"
            v-if="item.type === 'input'" :placeholder="item.placeholder"
            :maxlength="item.key === 'matrixName' ? 15 : null"></el-input>
          <!-- 选择 -->
          <el-radio-group clearable v-model="createMatrixForm[item.key]" v-if="item.type === 'radio'">
            <el-radio v-for="(v, index) in item.options" :key="index" :label="v.value">{{ v.label }}</el-radio>
          </el-radio-group>

          <!-- 下拉 -->
          <el-select v-model="createMatrixForm[item.key]" v-if="item.type === 'select'" filterable clearable
            :placeholder="item.placeholder">
            <el-option v-for="(v, index) in item.options" :key="index" :label="v.label" :value="v.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isCreateShow = false">取 消</el-button>
        <el-button type="primary" @click="createSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新建矩阵谷歌验证码 -->
    <DialogAction @config="createMatrixSubmit" @codeChange="(v) => (createMatrixCodeProp.code = v)"
      @close="createMatrixCodeProp.show = false" v-bind="createMatrixCodeProp" />
    <!-- 厂家标记 -->
    <TagDia ref="tagDia" @confirm="getList()" />
    <!-- 矩阵时间设置 -->
    <SettingDia ref="settingDia" @confirm="getList()" />
    <el-dialog title="矩阵设置" :visible.sync="isSetting" width="30%" :before-close="() => (isSetting = false)">
      <p class="tip" style="margin-bottom: 10px; margin-left: 20px">
        说明：设置后，按照设置取价时间显示在员工确认交易页面，并进行定时执行
      </p>
      <el-form :model="settingForm" ref="settingForm" class="time-input" label-position="left" label-width="110px">
        <el-form-item label="矩阵取价时间" prop="priceTime" :rules="[
          { required: true, message: '请输入取价时间', trigger: 'change' },
          { validator: timeValidator, trigger: 'blur' },
        ]">
          <el-input style="width: 70%" clearable @input="priceInput" v-model="settingForm.priceTime"
            placeholder="请输入取价时间，单位秒" />
          <span style="margin-left: 20px">秒</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isSetting = false">取 消</el-button>
        <el-button type="primary" @click="settingSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加回收商 -->
    <el-dialog title="添加回收商" v-if="isAddRecovery" :visible.sync="isAddRecovery" width="550px"
      :before-close="() => (isAddRecovery = false)">
      <el-form :model="addRecoveryForm" ref="recoveryForm" label-position="left" label-width="140px">
        <p v-if="moreChooseStore">
          已选择<span style="color: #0981ff; cursor: pointer">{{ tableChooseLength }}个</span>矩阵，可批量添加合作商家
        </p>
        <div @click="addRecoveryClick">
          <el-form-item label="选择报价回收商" prop="merchantName" :rules="[
            { required: true, message: '请选择回收商', trigger: 'change' },
          ]">
            <el-input style="width: 70%" clearable readonly suffix-icon="el-icon-arrow-right" @input="priceInput"
              v-model="addRecoveryForm.merchantName" placeholder="请选择回收商" />
          </el-form-item>
        </div>
        <div class="add-recover-info">
          <p>创建人：{{ addRecoveryForm.contactName || "--" }}</p>
          <p>联系电话：{{ addRecoveryForm.contactPhone || "--" }}</p>
        </div>
        <el-form-item label="选择分转仓" prop="warehouseId" v-if="
          (!moreChooseStore && currentData.isOut == '否') || moreChooseStore
        " :rules="[
          { required: true, message: '请选择仓库', trigger: 'change' },
        ]" style="margin-bottom: 0px; margin-top: 20px">
          <el-select clearable size="small" v-model="addRecoveryForm.warehouseId" placeholder="请选择仓库" filterable :disabled="!addRecoveryForm.merchantName">
            <el-option v-for="item in entrepotList1" :key="item.id" :label="item.warehouseName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手续費承担方" required style="margin-bottom: 0px; margin-top: 20px">
          <el-radio-group :value="0">
            <el-radio v-for="(item, index) in ['回收商承担', '门店商承担']" :key="index" :label="index" :disabled="index === 1">{{
              item }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <p class="tip" style="margin-left: 20px">
          说明：矩阵报价默认回收商承担手续费
        </p>
        <el-form-item v-if="!moreChooseStore" label="动态口令" size="medium" label-width="100px" prop="command" :rules="[
          { required: true, message: '请输入动态口令', trigger: 'blur' },
        ]">
          <el-input v-model="addRecoveryForm.command" placeholder="请输入谷歌动态验证码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isAddRecovery = false">取 消</el-button>
        <el-button type="primary" @click="addRecoverySubmit" v-loading="addRecoveryForm.loading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加回收商列表 -->
    <DialogTableSearch v-bind="addRecoveryProp" width="800px" @close="
      addRecoveryProp.show = false;
    addRecoveryProp.isResetForm = false;
    " @sizeChange="(v) => {
      addRecoveryProp = { ...addRecoveryProp, ...v };
      getRecoveryList();
    }
    " @pageChange="(v) => {
          addRecoveryProp = { ...addRecoveryProp, ...v };
          getRecoveryList();
        }
        " @handleConfirm="(v) => addRecoverySearch(v)" @config="addRecoveryConfig">
      <!-- 表插槽 -->
      <template v-slot="{ row, prop }">
        <div v-if="prop !== 'select'">
          {{ row[prop] }}
        </div>
        <div v-else>
          <el-checkbox :value="selectRecoveryData.merchantId === row.merchantId"
            @change="addRecoveryChange(row)"></el-checkbox>
        </div>
      </template>
    </DialogTableSearch>

    <!-- 矩陣报价回收商列表 -->
    <DialogTableSearch v-bind="recoveryNumProps" :isTabSelection="true" listKey="companyId" :isAction="true"
      :allSelectData="[]" @handleSelectionChange="merchantSelectionChange" @close="
        recoveryNumProps.show = false;
      recoveryNumProps.isResetForm = false;
      
      " @sizeChange="(v) => {
        recoveryNumProps = { ...recoveryNumProps, ...v };
        getRecoveryNumList();
      }
      " @pageChange="(v) => {
          recoveryNumProps = { ...recoveryNumProps, ...v };
          getRecoveryNumList();
        }
        " @handleConfirm="(v) => recoveryNumSearch(v)">
      <template v-slot:action>
        <el-button v-if="currentData.isOut !== '是'" @click="allTrunon" size="small"
          :disabled="merchantselectData.length === 0" type="warning">批量开启显示KA名称</el-button>
      </template>
      <!--从商户才显示-->
      <template v-slot:tab v-if="this.currentData.sm=='01'">
        <div class="button_top">
          <div class="radiobtn">
            <div class="faultBtn">
              <div v-bind:class="clickShow === '01' ? 'active' : 'none'" @click="BtnClick('01')">
                真实报价
              </div>
              <div v-bind:class="clickShow === '02' ? 'active' : 'none'" @click="BtnClick('02')">
                映射报价
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 表插槽 -->
      <template v-slot="{ row, prop }">
        <!-- 回收商名称 -->
        <div v-if="prop === 'merchantName'" class="fc_line">
          {{ row[prop] }}
        </div>
        <!-- 分转仓 -->
        <div v-else-if="prop === 'warehouseName'" class="fc_line">
          <el-select size="small"  :disabled="row.isupdata" v-model="row.warehouseId" placeholder="请选择仓库" filterable @visible-change="vchange(row)">
            <el-option v-for="item in entrepotList" :key="item.id" :label="item.warehouseName"
              :value="item.id"></el-option>
          </el-select>
          <div v-if="currentData.isOut == '否'">
            <div v-if="row.isupdata" @click="amendWarsh(row)" style="color: #f80000; text-decoration: underline">
              修改
            </div>
            <div v-else @click="saveWarsh(row)">保存</div>
          </div>
        </div>
        <!-- 合作门店 -->
        <div v-else-if="prop === 'configStores'">
          <!-- <div class="fc_line" @click="storeList(row,'01')">{{ row[prop] }}</div>
          <div class="fc_line" @click="storeList(row,'02')">添加</div> -->
          <div class="fc_line" @click="$refs['storeDia'].open(row, '01',clickShow)">
            {{ row[prop] }}
          </div>
          <!--从商户映射报价-->
          <!-- <div class="fc_line" @click="$refs['storeDia'].open(row, '03')" v-if="clickShow=='02'">
            {{ row[prop] }}
          </div> -->
          <!--从商户且映射报价不显示添加按钮-->
          <div class="fc_line" @click="$refs['storeDia'].open(row, '02',clickShow)" v-if="clickShow == '01'">
            添加
          </div>
        </div>
        <!--显示真实KA名称 -->
        <div v-else-if="prop === 'KAmerchantname'">
          <el-switch v-model="row.isDisplayRealName" @change="ErpMethodsSwitch($event, row)">
          </el-switch>
        </div>
        <!--映射报价-->
        <div v-else-if="prop === 'isEnbalequotation'">
          <el-switch v-model="row.isOpenMapping" @change="mapSwitch($event, row)">
          </el-switch>
        </div>
        <!-- 操作 -->
        <div v-else-if="prop === 'action'&&clickShow!=='02'">
          <div v-show="row.companyIsEnable !== '01'" class="fc" style="cursor: pointer" @click="quotationAction(row)">
            启用
          </div>
          <div v-show="row.companyIsEnable === '01'" style="color: #f80000; cursor: pointer"
            @click="quotationAction(row)">
            禁用
          </div>
        </div>
        <div v-else-if="prop === 'action'&&clickShow=='02'">
          <div v-show="row.companyIsEnable !== '01'"  style="cursor: pointer" @click="quotationAction(row)">
            启用
          </div>
          <div v-show="row.companyIsEnable === '01'" style=" cursor: pointer"
            @click="quotationAction(row)">
            禁用
        </div>
        </div>
        <!-- 其他 -->
        <div v-else>
          {{ row[prop] }}
        </div>
      </template>
    </DialogTableSearch>
    <StoreDia ref="storeDia" @confirm="recoveryNumSearch()" />
    <!-- 显示真实KA配置弹窗 -->
    <el-dialog title="操作提示" :visible.sync="uniformVisible" :close-on-click-modal="false" width="460px"
      @closed="unityDialogClosed">
      <div style="font-size: 13px; color: red">
        <span v-if="isUniformly">说明: 启用后，该回收商显示真实KA名称</span>
        <span v-else>说明: 关闭后，该回收商报价页面不在显示真实KA名称</span>
      </div>
      <div class="centercontent" v-if="isUniformly">
        是否确认开启所选<span style="color: #0981ff">{{ unitsNumber }}个回收商</span>在该矩阵显示真实KA名称?
      </div>
      <div class="centercontent" v-else>
        是否确认关闭<span style="color: #0981ff">{{
          mertcahantData.merchantName
        }}</span>在该矩阵显示真实KA名称?
      </div>
      <div class="command">
        <div>动态口令：</div>
        <el-input v-model="contactCommand" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="
          uniformVisible = false;
        contactCommand = '';
        ">取消</el-button>
        <el-button type="primary" @click.native="uniSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!--启用映射报价-->
        <el-dialog title="操作提示" :visible.sync="mapVisible" :close-on-click-modal="false" width="460px"
      @closed="mapDialogClosed">
      <div style="font-size: 13px; color: red;text-align: center;">
        <span v-if="isUniformly">说明:开启映射报价将自动处理开启从商户与回收商的合作关系</span>
        <span v-else>说明:关闭映射报价将自动处理开启从商户与回收商的合作关系</span>
      </div>
      <div class="centercontent" v-if="isUniformly">
        是否确认开启<span style="color: #0981ff">{{mertcahantData.merchantName }}</span>映射报价?
      </div>
      <div class="centercontent" v-else>
        是否确认关闭<span style="color: #0981ff">{{
          mertcahantData.merchantName
        }}</span>映射报价?
      </div>
      <div class="command">
        <div>动态口令：</div>
        <el-input v-model="contactCommand" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="mapVisible = false">取消</el-button>
        <el-button type="primary" @click.native="mapSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>
    <!-- 矩陣报价回收商门店列表 -->
    <DialogTableSearch v-bind="storeListProp" @close="
      storeListProp.show = false;
    storeListProp.isResetForm = false;
    " @handleConfirm="(v) => storeListSearch(v)" @handleSelectionChange="handleSelectionChange"
      @config="storeListConfig">
      <template v-slot="{ row, prop }">
        <!-- 回收商数量 -->
        <div v-if="prop === 'inquiryMerchantName'">
          <el-tooltip class="item" effect="dark" :content="row[prop]" placement="bottom-start">
            <div class="ycyc2">
              {{ row[prop] }}
            </div>
          </el-tooltip>
        </div>
        <!--  -->
        <div v-else-if="prop === 'selection'"></div>
        <div v-else>
          {{ row[prop] }}
        </div>
      </template>
      <template v-slot:action>
        <div style="width: 100%; overflow: hidden; margin-bottom: 10px">
          <div style="float: right">
            <el-button @click="storeExcle" :loading="storeListProp.isExcelLoading" type="success" size="mini"
              icon="el-icon-download">导出Excel
            </el-button>
          </div>
        </div>
      </template>
    </DialogTableSearch>

    <!-- 启用、禁用提示 -->
    <DialogAction v-bind="quotationTipProp" @close="quotationTipProp.show = false" @config="quotationConfig"
      @codeChange="(v) => (quotationTipProp.code = v)" />
    <el-dialog class="add-err-dialog" title='添加失败' :visible.sync="addErrShow" :close-on-click-modal="false"
      width="500px">
      <div style="margin-bottom: 10px">已过滤<span style="color:#FF687B;">{{ cooperationIds.length
          }}个</span>已在合作中的门店商户，可继续操作将剩余商户建立合作</div>
      <div class="err-info">
        <p style="margin-bottom: 10px">以下商户已在合作中:</p>
        <span style="color:#FF687B;">{{ cooperationName }}</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addErrShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="消息推送值设置" :visible.sync="pushFactorSetShow" width="30%" :close-on-click-modal="false">
      <p class="tip" style="margin-bottom: 10px;">
        说明：启用后，将使用订单号后7位除以推送数量，若得到整数则本单进入消息推送，若非整数则不进入消息推送
      </p>
      <div style="display: flex; align-items: center;">
        <span>启用按单号推送消息</span>
        <el-switch style="margin-left: 10px;" inactive-color="#bebebe"
          v-model="pushFactorSetForm.isOrderNoRule"></el-switch>
      </div>
      <div style="display: flex; align-items: center;margin-top:10px;" v-show="pushFactorSetForm.isOrderNoRule">
        <span>生效时间段设置：</span>
        <div class="selectTime">
          <el-time-select size="small" class="timeselect" placeholder="开始时间" v-model="pushFactorSetForm.inDayStartTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00',
              maxTime: pushFactorSetForm.inDayEndTime,
            }">
          </el-time-select>
        </div>
        <span style="margin: 0 5px">~</span>
        <div>
          <el-time-select size="small" class="timeselect" placeholder="结束时间" v-model="pushFactorSetForm.inDayEndTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00',
              minTime: pushFactorSetForm.inDayStartTime,
            }">
          </el-time-select>
        </div>
      </div>
      <div style="display: flex; align-items: center;margin-top:10px;" v-show="pushFactorSetForm.isOrderNoRule">
        <span>推送值设置：</span>
        <el-input style="width:300px" size="small" v-model="pushFactorSetForm.pushFactor" placeholder="请输入小于100的正整数"
          @input="validateInput"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pushFactorSetShow = false">取 消</el-button>
        <el-button type="primary" :loading="pushFactorSetLoading" @click="pushFactorSetSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置渠道编码" :visible.sync="isShowFxChanelCodeDialog" width="30%" :close-on-click-modal="false">
      <p class="tip" style="margin-bottom: 10px;">
        说明：该编码用于推送给外部设置后不可修改，请谨慎填写
      </p>
      <el-form ref="formRef" :model="fxChannelform" label-width="110px" label-position="left">
        <el-form-item label="繁星渠道编码" prop="channelCode" :rules="[
          { required: true, message: '请输入编码，最多20位', trigger: 'change' },
        ]">
          <el-input v-model="fxChannelform.channelCode" maxlength="20" placeholder="请输入编码，最多20位" />
        </el-form-item>
        <el-form-item label="动态口令" prop="command">
          <el-input v-model="fxChannelform.command" placeholder="请输入谷歌动态口令"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowFxChanelCodeDialog = false">取 消</el-button>
        <el-button type="primary" :loading="pushFactorSetLoading" @click="fxChannelCodeSetSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <MerchantBatchDia v-if="merchantBatchDiaShow" :dialogVisible="merchantBatchDiaShow"
      :merchantViewList="merchantViewList" @close="merchantBatchDiaShow = false" />
    <!--设置修改所属厂商弹窗-->
    <el-dialog class="add-err-dialog suffform" title='设置厂商' :visible.sync="showManufa" :close-on-click-modal="false"
      width="500px" @close="closeManufa" v-if="showManufa">
      <el-form ref="formRef1" :model="manufaform" label-width="80px" label-position="left" :rules="rules1">
        <el-form-item label="选择厂商" prop="manufaCode">
          <el-select v-model="manufaform.manufaCode" placeholder="请选择" filterable clearable :disabled="isdisabled">
            <el-option v-for="item in manufaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="动态口令" prop="command1" >
          <el-input v-model="manufaform.command1" placeholder="请输入谷歌动态口令"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="manufaType=='edit'">最近修改:{{manufacturerSetByName}} - {{manufacturerSetByAcc}} ({{manufacturerSetTime}})</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeManufa">取 消</el-button>
        <el-button type="primary" :loading="pushFactorSetLoading" @click="manufaSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="订单参数配置" :visible.sync="parameterConfiShow" width="900px" :close-on-click-modal="false" 
    @close="parameterConfiShow = false,detailsRow = {},parameterConfiTyop = '01',getList()">
      <div>
        当前商户：<span style="color: #0981ff;">{{ detailsRow.channelName }}>{{ detailsRow.companyName }} </span>
                 <div class="radiobtn" style="margin-top: 10px;">
            <div class="faultBtn">
              <div v-bind:class="parameterConfiTyop === '01' ? 'active' : 'none'"
                @click="parameterConfiTyop = '01'">
                订单参数
              </div>
              <div v-bind:class="parameterConfiTyop === '02' ? 'active' : 'none'"
                @click="parameterConfiTyop = '02'">
                功能配置
              </div>
            </div>
          </div>
        <el-table
         v-show="parameterConfiTyop === '01'"
    :data="parameterConfiData"
    style="width: 100%;margin: 15px 0;">
        <el-table-column
       
         label="序号"
      type="index"
      width="50"
      align="center"
      >
    </el-table-column>
    <el-table-column
      label="参数名称"
      align="center"
      prop="parameter"
      >
    </el-table-column>
<el-table-column
      label="上游订单是否有值"
      align="center"
      prop="isHas"
      >
    </el-table-column>
  </el-table>

  <el-table
  v-show="parameterConfiTyop === '02'"
    :data="parameterFunList"
    style="width: 100%;margin: 15px 0;">
    <el-table-column
         label="序号"
      type="index"
      width="50"
      align="center"
      >
    </el-table-column>
      <el-table-column
      label="功能名称"
      prop="funName"
      align="center"
      >
    </el-table-column>
    <el-table-column
      label="当前配置"
      align="center"
      >
  <template v-slot:default="scope">
      <span :style="{color:scope.row.lowestStartingPrice == '01' || scope.row.lowestStartingPrice == '02'?'#0981FF':'rgb(192, 196, 204)'}">
             {{scope.row.lowestStartingPrice == '01'?'可低于':scope.row.lowestStartingPrice == '02'?'不可低于':scope.row.lowestStartingPrice == '00'?'无法配置':'--'  }}
      </span>

       </template>
    </el-table-column>

    <el-table-column
      label="最近修改人"
      align="center"
      >
      <template slot-scope="scope">
     {{scope.row.operatorName  }}-{{scope.row.operatorAcc  }}
       </template>
    </el-table-column>
    <el-table-column
      prop="operatorTime"
      label="最近修改时间"
      align="center"
      >
 
    </el-table-column>
      <el-table-column
      label="操作"
      align="center"
      >
       <template slot-scope="scope">
          <div v-if="parameterConfiData[3].isHas == '是'"  @click="parFunRow =  scope.row,parFunShow = true" style="color: #FF687B;cursor: pointer;">修改</div>

        <div v-else style="color: grey;">
修改
        </div>
       </template>
    </el-table-column>
  </el-table>
</div>
    </el-dialog>
     <el-dialog title="功能配置" :visible.sync="parFunShow" width="600px" :close-on-click-modal="false" 
    @close="parFunShow = false,getMatDet()">

    <div>报价是否可低于起拍价</div>
   <el-radio-group v-model="parFunRow.lowestStartingPrice" style="margin: 30px 0;">
    <el-radio label="01">可低于</el-radio>
    <el-radio label="02">不可低于</el-radio>
  </el-radio-group>
    <div style="color: red;">说明：回收商报价/审单报价金额低于起拍价时，{{parFunRow.lowestStartingPrice == '01'?'仍可提交':'无法提交'}}</div>
  
    <div style="display: flex;justify-content: flex-end;padding: 15px;">
        <el-button  @click="parFunShow = false">取消</el-button>
  <el-button type="primary" @click="parFunSubmit()">确定</el-button>
    </div>

  </el-dialog>
    <el-dialog title="繁星推送报价节点" :visible.sync="nodeShow" width="900px" :close-on-click-modal="false" @close="nodeShow = false,getList(),detailsRow = ''">
      <div>
        当前商户：<span style="color: #0981ff;">{{ detailsRow.channelName }}>{{ detailsRow.companyName }}</span>
        <el-table
    :data="nodeData"
    style="width: 100%;margin: 30px 0;">
        <el-table-column
         label="序号"
      type="index"
      width="50"
      align="center"
      >
         
    </el-table-column>
    <el-table-column
      label="取价时间节点"
      prop="timeNode"
      align="center"
      >
      <template slot-scope="scope">
     第{{ numberToChinese(scope.row.timeNode) }}次
       </template>
    </el-table-column>
<el-table-column
      label="配置方式"
      align="center"
      prop="configType"
      >
      <template slot-scope="scope">
     {{ scope.row.configType == '01'?'按比例':'按固定时间' }}
       </template>
    </el-table-column>
    <el-table-column
      label="取价时间"
      align="center"
      width="200"
      >
       <template slot-scope="scope">
          {{ scope.row.configType == '01'?'渠道报价截止时长×':'下单后' }}<span style="color: #0981FF;">{{ scope.row.quoteTime }}{{ scope.row.configType == '01'?'%':'秒' }}</span>
       </template>
    </el-table-column>
    <el-table-column
      label="最近修改人"
      align="center"
      >
       <template slot-scope="scope">
          {{ scope.row.adminName }}-{{ scope.row.adminAcc }}
       </template>
    </el-table-column>
    <el-table-column
      label="最近修改时间"
      align="center"
       prop="updateTime"
      width="200"
      >
    </el-table-column>

  </el-table>
      </div>
    </el-dialog>

      <el-dialog title="售后配置" :visible.sync="afterSalesConfigShow" width="900px" :close-on-click-modal="false" @close="afterSalesConfigShow = false" >
        <div>当前商户：<span style="color: #0981ff;">{{ detailsRow.channelName }}>{{ detailsRow.companyName }}</span></div>
                <el-table
    :data="afterSalesConfigData"
    style="width: 100%;margin: 30px 0;">
        <el-table-column
         label="序号"
      type="index"
      width="50"
      align="center"
      >
    </el-table-column>
    <el-table-column
      label="设置内容"
      align="center"
      >
             <template slot-scope="scope">
          {{ scope.row.configType == '01'?'商户是否支持线上追差':scope.row.configType == '02'?'自动提交售后配置':'追差要求' }}
          
       </template>
    </el-table-column>
    <el-table-column
      label="当前配置"
      align="center"
      >
           <template slot-scope="scope">
<span style="color: #0981FF;">
  {{ configStates.find(item => item.configState === scope.row.configState).name }}
</span>
       </template>
    </el-table-column>
   <el-table-column
      label="最近修改人"
      align="center"
      >
       <template slot-scope="scope">
          {{ scope.row.adminName }}-{{ scope.row.adminAcc }}
       </template>
    </el-table-column>
     <el-table-column
      label="最近修改时间"
             prop="updateTime"
      align="center"
      >
    </el-table-column>
    <el-table-column label="操作"
      align="center"
    >
      <template slot-scope="scope">
        <el-button
        v-if="  scope.row.configState == '03'&& scope.row.configType == '02'"
          size="mini"
          type="text"
          @click="automaticallySubmitClick(scope.row)" >配置</el-button>
        <span v-else style="color: lightgrey;">无需人工配置</span>  
      </template>
    </el-table-column>
  </el-table>
     </el-dialog>
      <el-dialog title="自动提交外部售后配置" :visible.sync="automaticallySubmitVisible" :close-on-click-modal="false"
        width="900px" @closed="automaticallySubmitVisible = false, code = '',
        getAftermarketConfigs(),automaticallyClickShow = '01'
        automaticallyForm = {},$refs['automaticallyForm'].resetFields()
        ">
        <div class="button_top" >
          <div class="radiobtn">
            <div class="faultBtn">
              <div v-bind:class="automaticallyClickShow === '01' ? 'active' : 'none'"
                @click="automaticallyChange('01')">
                提交售后说明
              </div>
              <div v-bind:class="automaticallyClickShow === '02' ? 'active' : 'none'"
                @click="automaticallyChange('02')">
                提交售后配置
              </div>
            </div>
          </div>
        </div>
        <el-table :data="describeData" style="width: 100%;margin: 50px 0;" v-if="automaticallyClickShow == '01'">
          <el-table-column type="index" width="50" label="序号" align='center'>
          </el-table-column>
          <el-table-column prop="type" label="类型" width="160" align='center'>
            <template slot-scope="scope">
              <span style="font-weight: 800;">{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shuoming" label="取值说明" header-align='center'>
            <template slot-scope="scope" style="margin: 5px;">
              <div style="color: #0981FF;" v-for="(item, index) of scope.row.shuoming" :key="index">
                {{ item }}
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- <el-table :data="automaticallyTableData" style="width: 100%;margin: 50px 0;"
          v-if="automaticallyClickShow == '02'">
          <el-table-column type="index" width="50" label="序号" align='center'>
          </el-table-column>
          <el-table-column v-for="(item, index) of automaticallyColumn" :key="index" :prop="item.prop"
            :label="item.label" align='center'>
          </el-table-column>
                   <el-table-column  label="渠道唯一路由" align='center'>
            <template slot-scope="scope">
        {{ scope.row.code || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="isSubmit" label="初审通过自动向外部提交追差" align='center'>
            <template slot-scope="scope">
              <el-switch :disabled="!scope.row.isApr" v-model="scope.row.isSubmit" @change="autoAprChange(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table> -->
        <div  v-if="automaticallyClickShow == '02'" style="padding: 20px;">
          <div style="margin-bottom: 20px;">
          当前商户：<span style="color: #0981ff;">{{ detailsRow.channelName }}>{{ detailsRow.companyName }}</span>
          </div>
       
          <el-form :model="automaticallyForm"  ref="automaticallyForm"  >
          <el-form-item >
                      <el-switch
        v-model="automaticallyForm.isSubmit" style="margin-right: 5px;">
          </el-switch>启用自动提交售后
            </el-form-item>
            <el-form-item label="提交售后时机：">
            <el-radio-group v-model="automaticallyForm.submitAprPolicy">
                <el-radio label="00">平台初审通过</el-radio>
                <el-radio label="01">回收商申请追差</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="提交售后金额：">
            <el-radio-group v-model="automaticallyForm.submitAprPrice">
                <el-radio :disabled="automaticallyForm.submitAprPolicy  == '01'" label="00">平台初审通过金额</el-radio>
                <el-radio label="01">回收商申请追差金额</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div>最近修改： {{automaticallyForm.adminName? `${automaticallyForm.adminName}-${automaticallyForm.adminAcc} ${automaticallyForm.createTime}`:'暂无'}}</div>
           <div style="display: flex;justify-content: flex-end;padding: 15px;">
          <el-button @click.native="automaticallySubmitVisible = false">取消</el-button>
          <el-button type="primary"  @click.native="autoCommadShow = true">确定</el-button>
        </div>
        </div>
      </el-dialog>
      <el-dialog :title="codeTitle" :visible.sync="autocodeShow" :close-on-click-modal="false" width="500px"
        @closed="autocodeShow = false, autocode = '', getAutoApplyChannelList()">
        <div v-if="codeTitle != '操作提示'" style="color: red;">

          <span v-if="codeTitle ==
            '启用提示'">说明：开启后，该商户追差订单平台初审通过后将自动提交售后给外部。开启前请先了解启用说明</span>
          <span v-else>说明：关闭后，该商户追差订单平台初审通过后，不再自动提交售后给外部</span>
        </div>
        <div v-if="codeTitle == '操作提示'" class="cance-tip" style="margin-bottom: 20px;">
          <div class="tip-sure" style="margin-top: 10px;color: #333333;font-size: 16px;text-align: center;">是否确认导出？
          </div>
        </div>
        <div v-else
          style="font-weight: 600; display: flex;justify-content: center;align-items: center; margin: 15px 0;">
          <span>是否确认</span>
          <span>{{ automaticallyRow.isSubmit ? '开启' : '关闭' }}</span>
          <span style="color: #0981FF;">{{ automaticallyRow.companyName }}</span>
          <span>自动提交追差功能？</span>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <div style="width: 88px">动态口令：</div>
          <el-input v-model="autocode" placeholder="请输入谷歌动态口令"
            oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="autocodeShow = false, autocode = ''">取消</el-button>
          <el-button type="primary" :loading="excelLoading" @click.native="autocodeSubmit">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="操作提示" :visible.sync="autoCommadShow" width="500px"
        @closed="autoCommadShow = false, autocode = '', getAutoApplyChannelList()">
      <div style="display: flex;justify-content: center;align-items: center;margin: 20px 0;">是否确认修改售后配置？</div>
         
      <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <div style="width: 88px">动态口令：</div>
          <el-input v-model="autocode" placeholder="请输入谷歌动态口令"
            oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
        </div>
           <span slot="footer" class="dialog-footer">
          <el-button @click.native="autoCommadShow = false">取消</el-button>
          <el-button type="primary" :loading="excelLoading" @click.native="autocodeSubmit">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>
<script>
import GlobalInfoBar from "@/components/global/components/GlobalInfoBar.vue";
import GlobalChunk from "@/components/global/components/GlobalChunk.vue";
import {
  addRecoveryProps,
  createMatrixCode,
  createMatrixCodeProp,
  createMatrixForm,
  createMatrixFormList,
  createMatrixRules,
  listColumns,
  listFormList,
  quotationTipProp,
  recoveryNumProps,
  storeListProp,
  describeData
} from "@/views/matrix/initState";
import GlobalForm from "@/components/global/components/GlobalForm.vue";
import _api from "@/utils/request";
import { http } from "@/utils/request/matrix"
import {
  getIndex,
  getMeta,
  guideExcelAction,
  openAction,
  pageSize,
  setValue,
} from "@/utils/common";
import Pagination from "@/components/common/Pagination.vue";
import DialogTableSearch from "@/components/common/DialogTableSearch.vue";
import DialogAction from "@/components/common/DialogAction.vue";
import SettingDia from "./dialog/SettingDia.vue";
import TagDia from "./dialog/TagDia.vue";
import StoreDia from "./dialog/StoreDia.vue";
import MerchantBatchDia from "./dialog/MerchantBatchDia.vue";
import { Loading } from 'element-ui';
export default {
  name: "config",
  components: {
    DialogAction,
    DialogTableSearch,
    Pagination,
    GlobalForm,
    GlobalChunk,
    GlobalInfoBar,
    SettingDia,
    TagDia,
    StoreDia,
    MerchantBatchDia
  },
  data() {
    const { matrixId, matrixName } = this.$route.query;
    return {
      autocodeShow:false,
      autoCommadShow:false,
      // 01支持;02不支持；03可开启；04不可开启；05追差照片/视频必传 06 追差照片非必传视频必传 07追差照片必传 追差视频非必传 08追差照片视频非必传
      configStates:[
        {
          name:'支持',
          configState:'01'
        },
         {
          name:'不支持',
          configState:'02'
        },
         {
          name:'可开启',
          configState:'03'
        },
         {
          name:'不可开启',
          configState:'04'
        },
         {
          name:'追差照片/视频必传',
          configState:'05'
        },
         {
          name:'追差照片非必传视频必传',
          configState:'06'
        },
         {
          name:'追差照片必传 追差视频非必传',
          configState:'07'
        },
         {
          name:'追差照片视频非必传',
          configState:'08'
        },
      ],
      isUniformly: false,
      unitsNumber: 0,
      mertcahantData: [],
      contactCommand: "",
      uniformVisible: false,
      isbatch: false,
      merchantselectData: [],
      // 搜索from
      formItemList: listFormList,
      entrepotList: [],
      entrepotList1: [],
      // 表数据
      listData: [],
      initData: {
        matrixId: matrixName,
      },
      addStoreBtn: true,
      tableChooseLength: "",
      moreChooseStore: false,
      // 分页数据
      meta: {
        total: 0,
        pageSize,
        pageNum: 1,
      },
      // 是否加载
      loading: true,
      // 列表列
      listColumns,
      currentlistColumns:[],
      // 搜索参
      params: {
        pageSize,
        pageNum: 1,
        matrixId,
        isOut:true
      },
      moreCurrentData: [],
      // 谷歌验证码
      createMatrixCodeProp,
      // 矩陣新建
      isCreateShow: false,
      // // 门店商下拉
      // companyList: [],
      // // 回收商下拉
      // merchantList: [],
      // 外部商户
      outChannelList: [],
      // 创建矩阵form值
      createMatrixForm,
      // 创建矩到form列表
      createMatrixFormList,
      // 规则验证
      createMatrixRules,
      // 当前数据
      currentData: {},
      // 矩阵设置
      isSetting: false,
      // 取价时间
      settingForm: {
        priceTime: null,
      },
      // 添加回收商
      isAddRecovery: false,
      // 回收商选的数据，如果用戶点击了取消，需要保证原本确定选的依旧存在
      selectRecoveryData: {},
      // 添加回收商
      addRecoveryForm: {
        // 回收名称
        merchantName: "",
        command: "",
        // 矩阵id
        matrixId: "",
        // 回收商名称
        merchantId: "",
        // 联系人
        contactName: "",
        //仓库id
        warehouseId: "",
        // 联系电话
        contactPhone: "",
        loading: false,
      },
      // 添加回收商弹窗相关数据
      addRecoveryProp: addRecoveryProps,
      // 回收商数量
      recoveryNumProps,
      // 矩阵回收商关联门店列
      storeListProp,
      // 禁用启用报价提示
      quotationTipProp,
      addErrShow: false,
      cooperationIds: [],
      cooperationName: "",
      pushFactorSetShow: false,
      pushFactorSetLoading: false,
      rowId: "",
      pushFactorSetForm: {
        isOrderNoRule: false,
        inDayStartTime: "",
        inDayEndTime: "",
        pushFactor: ""
      },
      //是否显示繁星渠道编码对话框
      isShowFxChanelCodeDialog: false,
      fxChannelform: {
        channelCode: "",//繁星渠道码
        command: '', //繁星渠道码谷歌动态口令
        matrixId: ""
      },
      merchantViewList: [],
      merchantBatchDiaShow: false,
      status: "",//报价状态
      option: [

        {
          label: '已启用',
          value: "01"
        },
        {
          label: '已禁用',
          value: "02"
        }
      ],//报价状态
      disabled: true,//禁用
      manufacturer: "",//厂商
      manufaList: [],//厂商下拉数组
      manufaType: "add",
      showManufa: false,//设置修改所属厂商显隐
      manufacturer1: "",//弹框厂商
      manufaform: {
        manufaCode: "",
        command1: ""
      },
      clickShow: "01",
      isdisabled:false,
      mapVisible:false,//映射报价弹框
      manufacturerSetTime:"",
      manufacturerSetByName:"",
      manufacturerSetByAcc:"",
      submitLoading:false,
      rules1:{
          command1: [
            { required: true, message: '请输入动态口令', trigger: 'change' }
          ],
      },
      detailsRow:{},
      parameterConfiShow:false,
      parameterConfiTyop:'01',
        parameterConfiData: [{
        }],
        minId:0,
        parameterFunList:[],
        parFunShow:false,
        parFunRow:{},
        nodeShow:false,
        nodeData: [],
        afterSalesConfigShow:false,
        afterSalesConfigData:[],
        utomaticallySubmitVisible: false,
      automaticallyClickShow: '01',
      automaticallyColumn: [
        {
          prop: 'channelName',
          label: '渠道商名称'
        },
        {
          prop: 'companyName',
          label: '门店商户'
        },
        // {
        //   prop: 'code',
        //   label: '渠道商编号'
        // }
      ],
      automaticallyTableData: [],
      automaticallyForm: {},
      describeData,
       originDescribeData: [], // 存储 describeData 的原始副本
      automaticallyRow: {},
         detaleShow:false,
      detRow:{},
      codeTitle:'',
      autocode:'',
      inOrOutClickShow:'01',
      excelLoading:false,
      configurationId:'',
      configurationShow:false,
      configurationData:[{}],
      command:'',
      configurationSwitchShow:false,
      openOrClose:false,
      automaticallySubmitVisible:false
    };
  },
  created() {
    // 下拉请求
      this.getwarehouseSelectList();
    this.getSelectList();
    // 列表请求
    this.getList();
    this.createMatrixRules = {
      ...this.createMatrixRules,
      channelCode: [
        {
          validator: this.channelValidator,
          trigger: "blur",
        },
      ],
    };
    this.manufactureList()
    this.currentlistColumns = this.listColumns.filter(item => !['merchantName', 'companyNum'].includes(item.prop));
     this.originDescribeData = JSON.parse(JSON.stringify(this.describeData));
  },

  watch: {
    params() {
      this.getList();
    },
    //新建矩阵，外部渠道选择切换时
    "createMatrixForm.isOut"(v) {
      // 控制渠道索引
      const index = this.createMatrixFormList.findIndex(
        (v) => v.key === "channelCode"
      );
      // 控制回收商索引
      const merchantIndex = this.createMatrixFormList.findIndex(
        (v) => v.key === "merchantId"
      );
      // 设置显示
      this.createMatrixFormList[index].isShow = v;
      // 设置显示
      this.createMatrixFormList[merchantIndex].isShow = !v;
      if (v) {
        this.createMatrixRules.merchantId[0].required = false;
      } else {
        this.createMatrixRules.merchantId[0].required = true;
      }
    },
    formItemList(val) {
      if (val) {
        console.log(111)
      }

    }
  },

  methods: {
    openAction,

        parameterConfiClick(row){

          
          this.parameterConfiData = [
            {
              parameter:'门店id',
              isHas:row.hasStoreId == true?'是':'否'
            },
             {
              parameter:'店员id',
              isHas:row.hasStaffId == true?'是':'否'
            },
             {
              parameter:'预估价',
              isHas:row.hasPrePrice == true?'是':'否'
            },
                   {
              parameter:'起拍价',
              isHas:row.hasStartingPrice == true?'是':'否'
            },
          ]
           const {id} = row
          this.minId = id
          this.getMatDet()
       
          this.detailsRow = row
        this.parameterConfiShow=true
    },
    parFunSubmit(){
      const {lowestStartingPrice} = this.parFunRow
       _api.setLowestStartingPrice({id:this.minId,lowestStartingPrice}).then((res) => {
       this.parFunShow = false
      }); 
    },
    getMatDet(){
        
       _api.getMatrixOrderConfig(this.minId).then((res) => {
           this.parameterFunList = [
            {
              funName:'报价是否可低于起拍价',
             ...res.data[0]
            }
          ]
           }); 
    },
    nodeShowClick(row){
      this.detailsRow = row
        this.nodeShow=true
         const {routeId} = row
            _api.quoteNodes({routeId}).then((res) => {
              this.nodeData = res.data
      });  
    },
 numberToChinese(num) {
    if (isNaN(num) || num < 0) return '';
    
    const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const units = ['', '十', '百', '千', '万', '十', '百', '千', '亿'];
    
    let str = '';
    let numStr = num.toString();
    
    for (let i = 0; i < numStr.length; i++) {
      const digit = parseInt(numStr[i]);
      const unitIndex = numStr.length - 1 - i;
      
      if (digit !== 0) {
        str += digits[digit] + units[unitIndex];
      } else {
        // 处理零的情况
        if (str[str.length - 1] !== digits[0]) {
          str += digits[0];
        }
      }
    }
    
    // 移除末尾的零
    if (str[str.length - 1] === digits[0]) {
      str = str.slice(0, -1);
    }
    
    return str;
  },
    afterSalesConfig(row){
      this.detailsRow = row        
    this.afterSalesConfigShow = true
    this.getAftermarketConfigs()
    },
    getAftermarketConfigs(){
     const {channelCode,companyId,routeId,id} = this.detailsRow
            _api.aftermarketConfigs({channelCode,companyId,matrixId:id,routeId}).then((res) => {
              this.afterSalesConfigData = res.data
      }); 
    },
    detaleDialogSubmit(){
    this.detaleShow = false
    },
    automaticallySubmitClick(row) {
      
      this.getAutoApplyChannelList()
      console.log('automaticallySubmitClick',this.automaticallySubmitVisible);

    },
    getAutoApplyChannelList() {
      const {channelCode,id} =this.detailsRow
      console.log('this.detailsRow',this.detailsRow);
      http.autoApplyChannelList({channelCode,matrixId:id}).then((res) => {
        if(res.data.length != 0){
        let {submitAprPolicy,submitAprPrice} = res.data[0]
        this.automaticallyForm = {
          ...res.data[0],
          submitAprPolicy:submitAprPolicy?submitAprPolicy:'00',
          submitAprPrice:submitAprPrice?submitAprPrice:'00',
        }
        submitAprPolicy = this.automaticallyForm.submitAprPolicy
        submitAprPrice = this.automaticallyForm.submitAprPrice
        console.log('channelCode?.includes("fx-")',channelCode?.includes("fx-"));
        console.log('res.data[0]',res.data[0]);
        
        if (channelCode?.includes("fx-")) { // 加?.避免 channelCode 为 undefined
          // 从原始副本过滤第3项，生成新数组（不修改原始副本）
          this.describeData = this.originDescribeData.filter((_, i) => i !== 3);
        } else {
          // 恢复为原始副本（深拷贝，保证响应式）
          this.describeData = JSON.parse(JSON.stringify(this.originDescribeData));
        }
        console.log('channelCode',channelCode);
        
        if(channelCode == 'chx'){
          this.describeData.find(des => des.type === '追差类型').shuoming = ['取回收商选择的追差类型，追差类型与采货侠未绑定，则不会自动提交']

        if(submitAprPolicy == '01'){
          this.describeData.find(des => des.type === '追差备注').shuoming = ['回收商申请追差填写的内容，超出部分自动截取']

        }else if (submitAprPolicy == '00'){
          this.describeData.find(des => des.type === '追差备注').shuoming = ['初审通过平台审差填写的判责理由，超出部分自动截取']

        }
        }else if (channelCode != 'chx'){
          console.log(111);
          console.log('submitAprPolicy',submitAprPolicy);
          
        if(submitAprPolicy == '01'){
          console.log('111111');
          this.describeData.find(des => des.type === '追差备注').shuoming = ['回收商申请追差类型+回收商申请追差填写的内容，超出部分自动截取']
          
        
        }else if (submitAprPolicy == '00'){
          this.describeData.find(des => des.type === '追差备注').shuoming = ['回收商申请追差类型+初审通过平台审差填写的判责理由，超出部分自动截取']

        }
        }
        console.log('submitAprPolicy',submitAprPolicy);
        
        if(submitAprPolicy == '01'){
          this.describeData.find(des => des.type === '申请时机').shuoming = ['回收商申请追差时自动提交']


        }else if (submitAprPolicy == '00'){
          this.describeData.find(des => des.type === '申请时机').shuoming = ['平台初审通过时提交']
          
  
        }
       if(submitAprPrice == '00'){
          this.describeData.find(des => des.type === '申请金额').shuoming =[
      "初审通过门店商承担金额≤外部成交金额：取门店商承担金额",
      "初审通过门店商承担金额＞外部成交金额：取外部成交金额",
    ]


        }else if (submitAprPrice == '01'){
                this.describeData.find(des => des.type === '申请金额').shuoming =[
      "回收商申请金额≤外部成交金额：取回收商申请金额",
      "回收商申请金额＞外部成交金额：取外部成交金额",
    ] 

        }
      }
   
      this.automaticallySubmitVisible = true
      
      }).finally(() => {

      })
    },
        automaticallyChange(val) {
      this.automaticallyClickShow = val
    },

    // autoAprChange(row) {
    //   console.log(row, 111);
    //   const { isSubmit } = row
    //   this.automaticallyRow = row
    //   this.autocodeShow = true
    //   this.codeTitle = isSubmit ? '启用提示' : '禁用提示'
    // },
         autocodeSubmit() {
    if (!this.autocode) {
        return this.$message.error("请输入谷歌动态码");
      }
      this.excelLoading = true;
        http.automaticSubmission({  command: this.autocode ,...this.automaticallyForm}).then((r) => {
          this.excelLoading = false;
          this.autoCommadShow = false
          return this.$message.success(r.msg);

        }).finally((re)=>{
          this.excelLoading = false

        }) 
    },
    inOrOutChange(val) {
    if(val == '01'){
    this.currentlistColumns = this.listColumns.filter(item => !['merchantName', 'companyNum'].includes(item.prop));

    }else{
    this.currentlistColumns = this.listColumns.filter(item => !['Outchannel1', 'Outchannel','isManufacturers',
    'belongManufacturers','parameterConfi','quotationConfi',
    'afterSalesConfi'].includes(item.prop));
    }          
    this.inOrOutClickShow = val
    this.params = {
      ...this.params,
      pageNum:1,
      isOut:val == '01'?true:false
  }
      },
    configuration(){
       _api.getMatrixConfig({id:this.configurationId}).then((res) => {
       this.configurationData = res.data
      this.configurationShow = true
      });
    },
        configurationSwitch(){
    },
          configurationSwitchSubmit(){
                  if (!this.command) {
        return this.$message.error("请输入动态口令");
      }
            this.loading = true
             _api.openPlatformAutoCallExpress({command:this.command,id:this.configurationId,isOpen:this.openOrClose}).then((res) => {
        this.$message.success(res.msg)

            this.loading = false
              
      this.configurationSwitchShow = false

      }).finally(() => {
            this.loading = false
      
        });
    },
    uniSubmit() {
      let onprams = {
        command: this.contactCommand,
        isDisplayRealName: this.isUniformly,
        matrixId: this.currentData.id,
        merchantId: [],
      };
      if (this.isbatch) {
        onprams.merchantId = this.merchantselectData.map(item => item.merchantId)
      } else {
        onprams.merchantId.push(this.mertcahantData.merchantId)
      }
      console.log(onprams)
      _api.displayRealname(onprams).then((res) => {
        this.uniformVisible = false;
        this.isbatch = false;
        this.getRecoveryNumList();
      });
    },
    unityDialogClosed() {
      this.contactCommand = ''
      this.getRecoveryNumList();
    },
    mapDialogClosed() {
      this.mapVisible=false
      this.contactCommand = ''
      this.getRecoveryNumList();
    },
    ErpMethodsSwitch(e, row) {
      console.log(row);
      this.isbatch = false;
      this.isUniformly = row.isDisplayRealName;
      this.mertcahantData = row;
      this.uniformVisible = true;
      this.unitsNumber = 1;
    },
    //启用映射报价
    mapSwitch(e,row){
       console.log(row,"mylove");
      this.mapVisible=true
        this.isUniformly = row.isOpenMapping;
      this.mertcahantData = row;
    },
    //启用提交
        mapSubmit() {
      this.submitLoading=true
      let onprams = {
        command: this.contactCommand,
        isOpen: this.isUniformly,
        matrixId: this.currentData.id,
        merchantId:this.mertcahantData.merchantId,
      };
      let loadingInstance = Loading.service({text:"正在处理数据，请稍后"});
      // if (this.isbatch) {
      //   onprams.merchantId = this.merchantselectData.map(item => item.merchantId)
      //    console.log(this.merchantselectData,"this.currentData")
      // } else {
      //   onprams.merchantId.push(this.mertcahantData.merchantId)
      //    console.log(this.merchantselectData,"this.currentData")
      // }
      // console.log(onprams)
      // console.log(this.mertcahantData,"this.currentData")
      _api.updateMappingQuote(onprams).then((res) => {
        this.$message.success("已处理完成")
        this.mapVisible = false;
        this.isbatch = false;
        // this.getRecoveryNumList();
      }).finally(() => {
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
        });
          this.submitLoading=false
        });
    },
    allTrunon() {
      this.isbatch = true;
      this.isUniformly = true;
      this.unitsNumber = this.merchantselectData.length;
      this.uniformVisible = true;
    },
    vchange(row){
      console.log(row,99999999999)
      //this.currentData.id}

    },
    //获取仓库
    getwarehouseSelectList() {
      _api.getwarehouseSelectList().then((res) => {
        this.entrepotList = res.data;
      });
    },
    // 门店列表导表操作
    storeExcle() {
      this.storeListProp.isExcelLoading = true;
      _api
        .excelStoreInquiryMerchantList(this.storeListProp.params)
        .then((r) => {
          guideExcelAction(r, "报价回收商门店列表", () => {
            this.storeListProp.isExcelLoading = false;
          });
        });
    },
    storeListHref(row) {
      this.$router.resolve({
        path: "/StoreShop/index",
        query: { matrixId: row.id },
      });
    },
    // 设置数组项
    setArrItem(arr, label = "name", value = "id") {
      return arr.map((v) => {
        return {
          label: v[label],
          value: v[value],
        };
      });
    },
    // 总监区域下拉
    getInspectorAreaList(companyId) {
      _api.inspectorAreaSelect({ companyId }).then((r) => {
        r.data = Array.isArray(r.data) ? r.data : [];
        const index = this.storeListProp.formItemList.findIndex(
          (v) => v.key === "staffId"
        );

        this.storeListProp.formItemList[index].option = r.data.map((v) => {
          return {
            value: v.staffId,
            label:
              (v.staffName ? v.staffName : "") +
              (v.areaName ? "-" + v.areaName : ""),
          };
        });
      });
    },
    // 下拉，isFilterAdd新建商户，需要拿到没关联矩阵的商户，所以动态传参，不传代表初次进入，传代表新建时，重新拿门店和回收商下拉
    getSelectList(isFilterAdd = false) {
      if (!isFilterAdd) {
        // 矩阵下拉
        _api.getSelectMatrixList().then((r) => {
          const data = r.data || [];
          this.formItemList[0].option = this.setArrItem(data);
        });

        // 包含门店商户
        _api.getSelectList({ onlinePay: true }).then((r) => {
          const data = r.data || [];
          const index = this.formItemList.findIndex(
            (v) => v.key === "innerCompanyId"
          );
          this.formItemList[index].option = this.setArrItem(data);
        });
        // 包含回收商请求
        _api
          .listSimpleMerchantView({ isNice: "00", pageNum: 1, pageSize: 9999 })
          .then((r) => {
            const data = r.data || [];
            const index = this.formItemList.findIndex(
              (v) => v.key === "innerMerchantId"
            );
            this.merchantViewList = data
            const options = this.setArrItem(data, "merchantName", "merchantId");
            this.formItemList[index].option = options;
            // this.formItemList[index + 1].option = options;//隐藏
          });
      }

      // 门店商下拉
      _api.getMatrixCompanySelectList(isFilterAdd).then((r) => {
        const data = r.data || [];
        const companyList = this.setArrItem(data);
        if (isFilterAdd) {
          const index = this.createMatrixFormList.findIndex(
            (v) => v.key === "companyId"
          );
          this.createMatrixFormList[index].options = companyList;
        } else {
          this.formItemList[1].option = companyList;
        }
      });

      // 回收商下拉
      _api.getMatrixMerchantSelectList(isFilterAdd).then((r) => {
        const data = r.data || [];
        const merchantList = this.setArrItem(
          data,
          "merchantName",
          "merchantId"
        );
        if (isFilterAdd) {
          const index = this.createMatrixFormList.findIndex(
            (v) => v.key === "merchantId"
          );
          this.createMatrixFormList[index].options = merchantList;
        } else {
          this.formItemList[2].option = merchantList;
        }
      });

      if (isFilterAdd) {
        // 外部渠道
        _api.getOutChannelSelectList().then((r) => {
          const data = r.data || [];
          const index = this.createMatrixFormList.findIndex(
            (v) => v.key === "channelCode"
          );
          this.outChannelList = this.setArrItem(data, "value", "key");
          this.createMatrixFormList[index].options = this.outChannelList;
        });
      }
    },

    // 获取列表
    getList() {
      this.loading = true;
      _api.matrixList(this.params).then((r) => {
        const data = r.data.records || [];
        const params = this.params;
        this.loading = false;
        // 列
        this.listData = data.map((v, i) => {
          v = setValue(v);
          return {
            ...v,
            index: getIndex(params.pageNum, params.pageSize, i),
            isOut: v.isOut ? (v.isOut === "--" ? "--" : "是") : "否",
          };
        });
        // 分页
        this.meta = getMeta(r.data.total, r.data.current, r.data.size);
      }).finally(() => {
        if (typeof this.params.disuseLoding === 'function') {
          this.params.disuseLoding();
        }
      });
    },

    // 创建矩阵
    createClick() {
      this.isCreateShow = true;
      this.createMatrixForm = JSON.parse(JSON.stringify(createMatrixForm));
      this.getSelectList(true);
    },
    // 批量添加回收商
    handleTableSelect(val) {
      this.moreCurrentData = val.map((item) => {
        return item.id;
      });
      if (val.length) {
        this.addStoreBtn = false;
        this.tableChooseLength = val.length;
      } else {
        this.addStoreBtn = true;
      }
      console.log(val, "val");
    },
    addStore() {
      console.log(this.currentData, "curre");
      this.isAddRecovery = true;
      this.moreChooseStore = true;
    },
    // 搜索确定操作
    handleConfirm(v, cd) {
      console.log(v, "v111")//有新参数
      const { matrixName, matrixId } = this.$route.query;
      this.params = {
        ...this.params,
        pageNum: 1,
        companyIsEnable: this.status,//启用状态
        manufacturerId: this.manufacturer,//厂商
        ...v,
        matrixId: v.matrixId === matrixName ? matrixId : v.matrixId,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.listData = [];
    },
    // 外部渠道验证规则
    channelValidator(rule, value, callback) {
      if (this.createMatrixForm.isOut) {
        if (!value) {
          callback(new Error("请选择外部渠道商"));
        } else {
          callback();
        }
      }
      callback();
    },
    // 提交
    createSubmit() {
      this.$refs["createMatrix"].validate((v) => {
        if (v) {
          this.createMatrixCodeProp = {
            ...this.createMatrixCodeProp,
            show: true,
            code: "",
          };
        } else {
          return false;
        }
      });
    },

    // 谷歌验证码提交
    createMatrixSubmit() {
      if (this.createMatrixCodeProp.loading) {
        return;
      }
      if (!this.createMatrixCodeProp.code) {
        return this.$message.error("请输入谷歌动态码");
      }
      let data = {
        ...this.createMatrixForm,
        command: this.createMatrixCodeProp.code,
      };
      if (data.isOut) {
        data = {
          ...data,
          merchantId: null,
        };
      } else {
        data = {
          ...data,
          channelCode: null,
        };
      }
      this.createMatrixCodeProp = {
        ...this.createMatrixCodeProp,
        loading: true,
      };
      _api
        .matrixAdd(data)
        .then((r) => {
          this.isCreateShow = false;
          this.createMatrixCodeProp = {
            ...this.createMatrixCodeProp,
            show: false,
            loading: false,
          };
          this.$message.success("操作成功");
          this.params = {
            ...this.params,
            pageNum: 1,
          };
        })
        .catch(() => {
          this.createMatrixCodeProp = {
            ...this.createMatrixCodeProp,
            loading: false,
          };
        });
    },

    // 输入限制
    timeValidator(rule, value, callback) {
      if (Number(value) < 60) {
        return callback(new Error("报价时间设置值必须在60秒以上"));
      }
      callback();
    },

    // 矩阵设置
    settingClick(v) {
      this.isSetting = true;
      this.settingForm = {
        ...this.settingForm,
        priceTime: v.getPriceTime || null,
      };
      this.currentData = v;
    },

    // 价格时间变化
    priceInput(v) {
      let value = Number(v);
      if (isNaN(value)) {
        return (this.settingForm.priceTime = 60);
      }
      if (value > 600) {
        return (this.settingForm.priceTime = 600);
      }
    },

    // 矩阵设置提交
    settingSubmit() {
      const getPriceTime = Number(this.settingForm.priceTime);
      this.$refs["settingForm"].validate((v) => {
        if (v) {
          _api
            .matrixPrice({
              matrixId: this.currentData.id,
              getPriceTime,
            })
            .then(() => {
              this.$message.success("操作成功");
              this.isSetting = false;
              this.params = {
                ...this.params,
                pageNum: 1,
              };
            });
        } else {
          return false;
        }
      });
    },

    // 回收商列表请求
    getRecoveryList() {
      this.addRecoveryProp = {
        ...this.addRecoveryProp,
        loading: true,
      };
      _api.ShopTable(this.addRecoveryProp.params).then((r) => {
        const data = r.data || {};
        const tabData = (data.records || []).map((v) => {
          v = setValue(v);
          return v;
        });
        // 分页
        const meta = getMeta(r.data.total, r.data.current, r.data.size);
        // 更新状态
        this.addRecoveryProp = {
          ...this.addRecoveryProp,
          loading: false,
          meta,
          tabData,
        };
      });
    },

    // 添加回收商
    addRecovery(v) {
      console.log(v, "vv");
      this.currentData = v;
      this.isAddRecovery = true;
      this.addRecoveryForm = {};
      this.moreChooseStore = false;
    },

    // 添加回收商点击
    addRecoveryClick() {
      this.addRecoveryProp = {
        ...this.addRecoveryProp,
        show: true,
        params: {
          ...this.addRecoveryProp.params,
          pageNum: 1,
          merchantName: "",
        },
        isResetForm: true,
      };
      this.getRecoveryList();
      this.selectRecoveryData = this.addRecoveryForm;
      this.addRecoveryForm.loading = false;
    },

    // 查询
    addRecoverySearch(v) {
      this.addRecoveryProp = {
        ...this.addRecoveryProp,
        params: {
          ...this.addRecoveryProp.params,
          ...v,
          pageNum: 1,
        },
        tabData: [],
      };
      this.getRecoveryList();
    },
    // 回收商选择项变化
    addRecoveryChange(v) {
      console.log(v,1111)
      this.selectRecoveryData = {
        ...this.addRecoveryForm,
        merchantId: v.merchantId,
        contactName: v.contactName,
        contactPhone: v.contactPhone,
        merchantName: v.merchantName || "--",
      };
      if((!this.moreChooseStore && this.currentData.isOut == '否') || this.moreChooseStore){
            _api.getwarehouseSelectList({merchantId:v.merchantId}).then((res) => {
        this.entrepotList1 = res.data;
      });
      }

    },

    // 回收商选择确定
    addRecoveryConfig() {
      this.addRecoveryProp.show = false;
      this.addRecoveryForm = this.selectRecoveryData;
    },

    // 添加回收商
    addRecoverySubmit() {
      if (this.addRecoveryForm.loading) {
        return;
      }
      this.addRecoveryForm.loading = true;
      this.$refs["recoveryForm"].validate((v) => {
        if (v) {
          if (this.moreChooseStore == true) {
            const data = {
              matrixIdList: this.moreCurrentData,
              merchantId: this.addRecoveryForm.merchantId,
              warehouseId: this.addRecoveryForm.warehouseId,
            };
            _api
              .matrixMoreSaveUnionMerchant(data)
              .then((r) => {
                if (r.data && r.data.repeatMiddleMatrixList && r.data.repeatMiddleMatrixList.length) {
                  this.cooperationIds = r.data.repeatMiddleMatrixList.map(item => item.id);
                  this.cooperationName = r.data.repeatMiddleMatrixList.map(item => item.name).join('、');
                  const matchedItems = this.listData.filter(item => this.cooperationIds.includes(item.id));
                  console.log(matchedItems, 'matchedItemsmatchedItemsmatchedItemsmatchedItems')
                  this.toggleSelection(matchedItems)
                  this.addErrShow = true
                } else {
                  this.$message.success("操作成功");
                  this.isAddRecovery = false;
                  this.params = {
                    ...this.params,
                    pageNum: 1,
                  };
                  this.addRecoveryForm.merchantName = "";
                  this.addRecoveryProp = {
                    ...this.addRecoveryProp,
                    isResetForm: false,
                  };
                }
                this.addRecoveryForm.loading = false;
              })
              .catch(() => {
                this.addRecoveryForm.loading = false;
              });
          } else {
            const data = {
              command: this.addRecoveryForm.command,
              matrixId: this.currentData.id,
              merchantId: this.addRecoveryForm.merchantId,
              warehouseId: this.addRecoveryForm.warehouseId,
            };
            _api
              .matrixSaveUnionMerchant(data)
              .then((r) => {
                this.$message.success("操作成功");
                this.isAddRecovery = false;
                this.params = {
                  ...this.params,
                  pageNum: 1,
                };
                this.addRecoveryForm.merchantName = "";
                this.addRecoveryProp = {
                  ...this.addRecoveryProp,
                  isResetForm: false,
                };
                this.addRecoveryForm.loading = false;
              })
              .catch(() => {
                this.addRecoveryForm.loading = false;
              });
          }
          return;
        }
        this.addRecoveryForm.loading = false;
        return false;
      });
    },

    // 回收商查看
    recoveryNum(v) {
      this.recoveryNumProps = recoveryNumProps
      console.log(v,"v")
      console.log("鄙视盗号的和韩国法院")
      this.currentData = v;
      console.log(this.currentData,"this.currentData");
       console.log(this.currentData.sm,"this.currentData.sm");
      this.clickShow = "01",
        this.recoveryNumProps = {
          ...this.recoveryNumProps,
          params: {
            ...this.recoveryNumProps.params,
            companyId: v.companyId,
            merchantName: null,
            pageNum: 1,
            companyIsEnable: null,
            
          },
          show: true,
          isResetForm: true,
        };
        if(this.currentData.sm=="01"){
           this.recoveryNumProps.params.isOpenMapping=false
        }
        console.log(this.recoveryNumProps,"this.recoveryNumProps")
      //普通回收商、从商户不显示映射报价列,主商户显示
      if(this.currentData.sm=="--"||this.currentData.sm=="01"){
        this.recoveryNumProps.formItemList=this.recoveryNumProps.formItemList.filter(item => item.key != 'isOpenMapping')
        this.recoveryNumProps.tableColumns = this.recoveryNumProps.tableColumns.filter(item => item.prop != 'isEnbalequotation')
      }
      if (this.currentData.isOut == '是') {
        this.recoveryNumProps.tableColumns = this.recoveryNumProps.tableColumns.filter(item => item.prop != 'KAmerchantname')
      } else {
        if (this.recoveryNumProps.tableColumns.filter(item => item.prop == 'KAmerchantname').length) {
          console.log("不用处理")
        } else {
          this.recoveryNumProps.tableColumns.splice(this.recoveryNumProps.tableColumns.length - 1, 1, {
            prop: "KAmerchantname",
            label: "显示真实KA名称",
          },
            {
              prop: "action",
              label: "操作",
            })
        }

      }
      this.getRecoveryNumList();
    },
    amendWarsh(row) {
      row.isupdata = !row.isupdata;
        _api.getwarehouseSelectList({merchantId:row.merchantId}).then((res) => {
        this.entrepotList = res.data;
      });
    },
    saveWarsh(row) {
      this.getwarehouseSelectList();
      // row.isupdata = !row.isupdata;
      _api
        .updateMerchantWarehouse({
          matrixId: row.matrixId,
          merchantId: row.merchantId,
          warehouseId: row.warehouseId,
        })
        .then((res) => {
          this.getRecoveryNumList();
        });
    },

    // 回收商数量rq
    getRecoveryNumList() {
      this.recoveryNumProps = {
        ...this.recoveryNumProps,
        loading: true,
      };
      const { params } = this.recoveryNumProps;
      console.log(params,"params")
      _api.unionMerchantList(params).then((r) => {
        // 分页
        const meta = getMeta(r.data.total, r.data.current, r.data.size);
        const data = r.data || {};
        let records = data.records || [];
        // this.getwarehouseSelectList();
        this.recoveryNumProps = {
          ...this.recoveryNumProps,
          loading: false,
          meta,
          tabData: records.map((v, i) => {
            v = setValue(v);
            return {
              ...v,
              isupdata: true,
              index: getIndex(params.pageNum, params.pageSize, i),
            };
          }),
        };
      });
    },
    // 回收商搜索
    recoveryNumSearch(v) {
      console.log(v, "v")
      console.log(this.recoveryNumProps, "this.recoveryNumProps,")
      this.recoveryNumProps = {
        ...this.recoveryNumProps,
        tableData: [],
        params: {
          ...this.recoveryNumProps.params,
          pageNum: 1,
          ...v,
        },
      };
      console.log(this.recoveryNumProps, "this.recoveryNumProps111,")
      this.getRecoveryNumList();
    },
    //真实报价
    BtnClick(type) {
      console.log(type,"type")
      let bool
      this.clickShow = type;
      if(this.clickShow=="01"){
        bool=false
      }
      if(this.clickShow=="02"){
        bool=true
      }
      console.log(bool,"bool")
      this.recoveryNumProps = {
        ...this.recoveryNumProps,
        tableData: [],
        params: {
          ...this.recoveryNumProps.params,
          pageNum: 1,
          companyIsEnable: "",
          isQuotation: "",
          merchantName: "",
          isOpenMapping:bool,
        },
      };
      this.getRecoveryNumList();
    },
    // 回收商禁用启用
    quotationAction(v) {
      if(this.clickShow=='02'){
        console.log(99999,"999")
        if(v.companyIsEnable === '01'){
          this.$message.warning("请在主商户禁用报价")
          return false
        }
        else{
        this.$message.warning("请在主商户启用报价")
         return false
        }
      }
      const isType = v.companyIsEnable === "01";
      this.quotationTipProp = {
        ...this.quotationTipProp,
        show: true,
        code: "",
        currentData: v,
        width: "30%",
        isType,
        title: !isType ? "启用提示" : "禁用提示",
        tipText: !isType
          ? "是否确认启用该商家报价？"
          : "是否确认禁用该商户参与矩阵报价",
      };
      
    },

    // 回收商禁用启用确定
    quotationConfig() {
      // closeQuote 关闭报价
      // saveUnionMerchant 开启报价
      let rq;
      const { isType, code, currentData } = this.quotationTipProp;
      if (!code) {
        return this.$message.error("请输入动态口令");
      }
      let params = {
        command: code,
        companyId: currentData.companyId,
        merchantId: currentData.merchantId,
      };

      // 启用
      if (!isType) {
        console.log(this.currentData);
        params = {
          command: code,
          merchantId: currentData.merchantId,
          matrixId: this.currentData.id,
          warehouseId: currentData.warehouseId,
        };
        rq = _api.matrixSaveUnionMerchant;
      } else {
        rq = _api.closeQuote;
      }
      params.warehouseId = params.warehouseId === '--' ? '' : params.warehouseId
      rq(params).then(() => {
        this.$message.success("操作成功");
        this.quotationTipProp = {
          ...this.quotationTipProp,
          show: false,
        };
        // 重新更新数据
        this.getRecoveryNumList();
      });
    },

    // 矩阵回收商关联的门店列表rq
    getStoreList() {
      this.storeListProp = {
        ...this.storeListProp,
        loading: true,
      };
      const { params } = this.storeListProp;
      _api.storeInquiryMerchantList(params).then((r) => {
        let data = (r.data || []).map((v, i) => {
          v = setValue(v);
          return {
            ...v,
            index: i + 1,
          };
        });
        this.storeListProp = {
          ...this.storeListProp,
          loading: false,
          tabData: data,
          allTabData: data,
        };
      });
    },

    // 矩阵回收商关联门店搜索
    storeListSearch(v) {
      this.storeListProp.params = {
        ...this.storeListProp.params,
        ...v,
      };
      const allTabData = this.storeListProp.allTabData;
      // 都不存在
      if (!v.staffId && !v.name && !v.merchantNum && v.merchantNum !== 0) {
        return (this.storeListProp = {
          ...this.storeListProp,
          tabData: allTabData,
        });
      }

      // 只搜索总监
      if (v.staffId && !v.name && !v.merchantNum && v.merchantNum !== 0) {
        return (this.storeListProp = {
          ...this.storeListProp,
          tabData: allTabData.filter((item) => item.inspectorId == v.staffId),
        });
      }

      // 只搜索名称
      if (!v.staffId && v.name && !v.merchantNum && v.merchantNum !== 0) {
        return (this.storeListProp = {
          ...this.storeListProp,
          tabData: allTabData.filter(
            (item) => item.storeName.indexOf(v.name) >= 0
          ),
        });
      }
      //只搜索回收商数量
      if (!v.staffId && !v.name && (v.merchantNum || v.merchantNum === 0)) {
        return (this.storeListProp = {
          ...this.storeListProp,
          tabData: allTabData.filter(
            (item) =>
              parseInt(item.inquiryMerchantNum) === parseInt(v.merchantNum)
          ),
        });
      }

      // 都搜索
      if (v.staffId && v.name && (v.merchantNum || v.merchantNum === 0)) {
        return (this.storeListProp = {
          ...this.storeListProp,
          tabData: allTabData.filter(
            (item) =>
              v.staffId == item.inspectorId &&
              item.name.indexOf(v.name) >= 0 &&
              parseInt(item.inquiryMerchantNum) === parseInt(v.merchantNum)
          ),
        });
      }
    },
    // 矩阵回收商关联的门店列表
    storeList(row, enable) {
      this.storeListProp = {
        ...this.storeListProp,
        show: true,
        isResetForm: true,
        params: {
          enable,
          merchantId: row.merchantId,
          matrixId: this.currentData.id,
        },
        selectData: [],
        allSelectData: [],
        currentData: row,
      };
      if (enable === "01") {
        this.storeListProp = {
          ...this.storeListProp,
          title: "移除门店",
          configText: "确定移除",
        };
      } else {
        this.storeListProp = {
          ...this.storeListProp,
          title: "添加门店",
          configText: "确定添加",
        };
      }
      // 区域/总监
      this.getInspectorAreaList(this.currentData.companyId);
      // 门店list
      this.getStoreList();
    },
    merchantSelectionChange(e) {
      console.log(e);
      this.merchantselectData = e;
    },
    // 矩陣回收商门店选择项添加或者删除操作
    handleSelectionChange(val) {
      this.storeListProp = {
        ...this.storeListProp,
        // 选择的所有数据
        allSelectData: val,
        selectData: val.map((v) => v.id),
      };
    },
    // 矩阵回收商门店添加或者移除确定操作
    storeListConfig() {
      const storeIds = this.storeListProp.selectData;
      const enable = this.storeListProp.params.enable;
      const data = {
        storeIds,
        matrixId: this.currentData.id,
        merchantId: this.storeListProp.currentData.merchantId,
      };
      if (enable === "01") {
        data.enable = "02";
      } else {
        data.enable = "01";
      }

      _api.doStoreInquiryMerchant(data).then((r) => {
        this.$message.success("操作成功");
        this.storeListProp = {
          ...this.storeListProp,
          show: false,
          allSelectData: [],
          isResetForm: false,
        };
        // 重新请求
        this.recoveryNumSearch();
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.listData.toggleRowSelection(row);
        });
      }
    },
    // 消息推送值设置
    openPushFactorSet(row) {
      console.log(row)
      this.rowId = row.id
      this.pushFactorSetShow = true
      this.pushFactorSetForm.isOrderNoRule = row.isOrderNoRule === '--' ? false : row.isOrderNoRule
      this.pushFactorSetForm.pushFactor = row.pushFactor == '--' ? '' : row.pushFactor
      if (row.timeRange !== '--') {
        let timeRangeArr = row.timeRange.split('-')
        this.pushFactorSetForm.inDayStartTime = timeRangeArr[0]
        this.pushFactorSetForm.inDayEndTime = timeRangeArr[1]
      } else {
        this.pushFactorSetForm.inDayStartTime = ""
        this.pushFactorSetForm.inDayEndTime = ""
      }
    },
    validateInput(value) {
      // 只保留数字字符
      const num = value.replace(/[^0-9]/g, '');
      // 转换为整数
      const intValue = parseInt(num, 10);
      // 检查是否为有效的正整数
      if (!isNaN(intValue) && intValue > 0 && intValue <= 100) {
        this.pushFactorSetForm.pushFactor = intValue;
      } else if (intValue > 100) {
        this.pushFactorSetForm.pushFactor = 100
      } else {
        // 如果不符合条件，清空输入或设置为最后一个有效值
        this.pushFactorSetForm.pushFactor = '';
      }
    },
    pushFactorSetSubmit() {
      if (this.pushFactorSetForm.isOrderNoRule) {
        if (!this.pushFactorSetForm.inDayStartTime || !this.pushFactorSetForm.inDayEndTime) {
          return this.$message.error('请补全生效时间段');
        }
        if (!this.pushFactorSetForm.pushFactor) {
          return this.$message.error('请输入推送值');
        }
      }
      console.log(this.pushFactorSetForm);
      let params = {
        isOrderNoRule: this.pushFactorSetForm.isOrderNoRule,
        pushFactor: this.pushFactorSetForm.pushFactor,
        matrixId: this.rowId,
        timeRange: this.pushFactorSetForm.inDayStartTime + '-' + this.pushFactorSetForm.inDayEndTime,
      };
      this.pushFactorSetLoading = true
      _api.saveMessagePushConfig(params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg || '操作成功');
          this.pushFactorSetShow = false
          this.getList()
        }
      }).finally(() => {
        this.pushFactorSetLoading = false;
      });
    },
    openMerchantBatchDia() {
      this.merchantBatchDiaShow = true
    },
    //设置繁星渠道编码弹框显示
    setChanelCode(id) {
      this.fxChannelform.channelCode = ""
      this.fxChannelform.command = ""
      this.fxChannelform.matrixId == ""
      this.isShowFxChanelCodeDialog = true
      this.fxChannelform.matrixId = id
    },
    //提交繁星渠道码设置
    fxChannelCodeSetSubmit() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          let param = {
            command: this.fxChannelform.command,
            matrixId: this.fxChannelform.matrixId,
            fxChannelCode: this.fxChannelform.channelCode
          }
          http.setMatrixCode(param).then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg || '操作成功');
              this.isShowFxChanelCodeDialog = false
              this.fxChannelform.channelCode = ""
              this.fxChannelform.command = ""
              this.fxChannelform.matrixId == ""
              this.getList()
            }
          }).catch(err => {

          })
        }

      })

    },
    handleChange(item, value) {
      console.log(value, 111111)
      if (value) {
        this.disabled = false
        //   if(item.key=="innerMerchantId"){
        //     this.formItemList.forEach(item1=>{
        //       if(item1.key=="sxwx"){

        //       }
        //     })
        // }
      }
      if (!value) {
        this.disabled = true
        this.status = ""
        if (item.key == "innerMerchantId") {
          console.log(this.formItemList, "9999")
          this.formItemList.forEach(item1 => {
            if (item1.key == "sxwx") {
              console.log(item1, 9999999)

            }
          })
        }
      }
    },
    //设置修改所属厂商弹窗
    setManufa(row, type) {
      this.manufaform.manufaCode=""
      this.manufaform.command1=""
      this.manufacturerSetTime=''
      this.manufacturerSetByName=''
      this.manufacturerSetByAcc=''
      this.showManufa = true
      this.id = row.id
      this.manufaType = type
       this.$refs["formRef1"]?.resetFields();
      // if (type == "add") {

      // }
      if (type == "edit") {
        this.manufaList.map(item => {
          if (item.name == row.manufacturerName) {
            this.manufaform.manufaCode = item.id
          }
        })
        //标记为主商户或者启用了从商户,禁用不可修改厂商
        if(row.sm=="00"){
          this.isdisabled=true
        }
        this.manufacturerSetTime=row.manufacturerSetTime
        this.manufacturerSetByName=row.manufacturerSetByName
        this.manufacturerSetByAcc=row.manufacturerSetByAcc
      }
    },

    //关闭所属厂商弹窗
    closeManufa() {
      this.showManufa = false
      this.id = ""
      this.manufaType = "add"
      this.isdisabled=false
      // this.manufaform.manufaCode=""
      // this.manufaform.command1=""
      this.$refs["formRef1"]?.resetFields();
    },
    //设置修改所属厂商提交
    manufaSubmit() {
          this.$refs.formRef1.validate((valid) => {
          if (valid) {
             _api.updateMatrixManufacturer({ matrixId: this.id, command: this.manufaform.command1, manufacturerId: this.manufaform.manufaCode }).then(res => {
            if (res.code == 1) {
              this.getList()
              this.closeManufa()
            }
          })  
          } else {
            console.log('error submit!!');
            return false;
          }
        });

    },
    //启用禁用提示
    enbale(type) {
      if (type) {
        this.message.warning("请在主商户启用报价")
      }
      else {
        this.message.warning("请在主商户禁用报价")
      }
    },
    //厂商下拉列表
    manufactureList() {
      _api.manuList().then(res => {
        if (res.code == 1) {
          this.manufaList = res.data
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.header-icon {
  display: flex;
  align-items: center;

  >img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    transform: translateY(1px);
  }

  >h2 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }
}

.fc {
  color: #0981ff;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.fc_line {
  color: #0981ff;
  text-decoration: underline;
  cursor: pointer;
}

.fc_line.danger {
  color: #f93636;
}

.f-line {
  text-decoration: underline;
}

.tip {
  color: #ff687b;
  font-size: 12px;
  margin-bottom: 20px;
}

.create-form {
  /deep/ .el-radio {
    margin-bottom: 20px;
  }
}

.time-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #666666;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.required::before {
  content: "*";
  color: #ff687b;
  margin-right: 4px;
  font-size: 14px;
}

.add-recover-info {
  margin-top: 20px;
  display: flex;
  padding-left: 19px;
  color: #111;
  font-size: 14px;
  width: 90%;
  justify-content: space-between;

  >p {
    margin-right: 20px;

    &:last-of-type {
      flex: 2;
    }

    &:first-of-type {
      flex: 3;
    }
  }
}

.ycyc2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.centercontent {
  font-size: 16px;
  color: #666666;
  text-align: center;
  margin: 20px 0;
  // height: 80px;
  // line-height: 80px;
}

.command {
  display: flex;
  align-items: center;
}

.command .el-input {
  width: 80%;
}

.err-info {
  background: #f5f6fa;
  padding: 20px;
  border-radius: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.timeselect.el-date-editor {
  /deep/ .el-input__inner {
    width: 200px;
  }
}

// .suffform {
//   /deep/ .el-form-item__content{
//     margin-left: 70px !important;
//   }
// }
.button_top {
  cursor: pointer;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faultBtn {
  width: 250px;
  height: 42px;
  background: #f9fbfd;
  border: 1px solid #c1d1ff;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 21px;
  display: flex;
cursor: pointer;
  .active {
    text-align: center;
    color: white;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    background: #0981ff;
    border-radius: 20px;
  }

  .none {
    text-align: center;
    color: #333;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    border-radius: 20px;
  }
}
</style>
